import React from "react";
import RequestPopupBody from "./RegularPopupBody";
import { Modal } from "react-bootstrap";
import Popup from "../../../Helpers/Popup/Popup";
import PopupTitle from "../../../Helpers/Popup/PopupParts/PopupTitle";
import Close from "../../../Helpers/CloseBtn/Close";
import Button from "../../../Helpers/Button/Button";

const RequestPopup = ({ id, onClose, title }) => {
  return (
    <Popup size={"xl"} show={!!id}>
      {/* {isLoading && (
        <div className="loader-container">
          <Loader />
        </div>
      )} */}
      <Modal.Header className="modal-header flex-between">
        <Modal.Title id="contained-modal-title-vcenter">
          <PopupTitle headtitle={`Assign Vehicles To ${title}`} />
        </Modal.Title>
        <div className="flex-row gap-16">
          <Close
            // eslint-disable-next-line react/style-prop-object
            style="expand"
            close={() => onClose()}
            img="expand"
          />
          <Close
            // eslint-disable-next-line react/style-prop-object
            style="close-32 close"
            close={() => onClose()}
            img="Close"
          />
        </div>
      </Modal.Header>
      <Modal.Body className="modal-body-scrollable">
        <RequestPopupBody />
      </Modal.Body>
      <Modal.Footer>
        <Button
          type="default"
          htmlType="button"
          text="Cancel"
          onClick={() => onClose()}
        />
        <Button
          text="Assign Vehicles"
          htmlType="submit"
          type="primary"
        />
      </Modal.Footer>
    </Popup>
  );
};

export default RequestPopup;
